import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const FuelCardPage = lazy(() => import('@cobliteam/fuel-card'));

const routes = [
  {
    title: 'Gestão de combustível',
    path: Location.FUEL_CARD,
    team: 'squad-gf-core',
    component: FuelCardPage,
    accessDeniedDescription: 'ver informações de gestão de combustível',
    routes: [
      {
        title: 'Gestão de combustível',
        path: Location.FUEL_CARD_DASHBOARD,
        component: FuelCardPage,
        accessDeniedDescription: 'ver informações de gestão de combustível',
        exact: true,
      },
      {
        title: 'Gestão de combustível',
        path: Location.FUEL_CARD_TOTAL_BY_VEHICLE,
        component: FuelCardPage,
        accessDeniedDescription: 'ver informações de gestão de combustível',
        exact: true,
      },
      {
        title: 'Gestão de combustível',
        path: Location.FUEL_CARD_TRANSACTION_HISTORY,
        component: FuelCardPage,
        accessDeniedDescription: 'ver informações de gestão de combustível',
        exact: true,
      },
      {
        title: 'Gestão de combustível',
        path: Location.FUEL_CARD_ASSOCIATIONS,
        component: FuelCardPage,
        accessDeniedDescription: 'ver informações de gestão de combustível',
        exact: true,
      },
    ],
  },
];

export default routes;
